import { render, staticRenderFns } from "./InfraFirewall.vue?vue&type=template&id=3bc444bf&"
import script from "./InfraFirewall.vue?vue&type=script&lang=js&"
export * from "./InfraFirewall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports